var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#DA1E27",
    strokeWidth: 2,
    transform: "translate(-970 -506) translate(352 389) translate(619 118)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DA1E27",
    fillRule: "nonzero",
    d: "M9.747 15.999V9.936c0-.68.552-1.232 1.232-1.232.68 0 1.231.552 1.231 1.232v6.063c0 .68-.551 1.231-1.231 1.231S9.747 16.68 9.747 16zm1.231-8.638c-.706 0-1.313-.5-1.45-1.192-.138-.693.233-1.386.886-1.656.652-.27 1.404-.041 1.796.546.392.587.315 1.37-.185 1.869-.278.277-.654.433-1.047.433z",
    transform: "translate(-970 -506) translate(352 389) translate(619 118) rotate(180 10.98 10.815)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failed-icon.dfa67b1cd44a119f431a16f06d371862.svg";
export { ForwardRef as ReactComponent };